import {configureStore} from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import {persistStore} from 'redux-persist'
import {rootReducer, rootSaga} from './RootReducer'
import { customersApi } from '@/modules/customers/api/customersApi'
import { rolesApi } from '@/modules/users/api/rolesApi'
import { usersApi } from '@/modules/users/api/usersApi'

const sagaMiddleware = createSagaMiddleware()

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
      thunk: true,
    }).concat(sagaMiddleware, customersApi.middleware, rolesApi.middleware, usersApi.middleware),
  devTools: process.env.NODE_ENV !== 'production',
})

export type AppDispatch = typeof store.dispatch


export const persistor = persistStore(store)

sagaMiddleware.run(rootSaga)

export default store
